<div class="modal-header border-bottom">
  <h5 class="fw-bold mb-0">Calendar Event Added</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <div class="d-flex align-items-center gap-2 p-3 rounded border mb-3"
       style="background-color: #D1E7DD; color: #00AE42;">
    <i class="bi bi-check-circle-fill fs-5"></i>
    <span>{{ projectTypeName() }} install event successfully added.</span>
  </div>

  @if (remainingProjectCount() > 0) {
    <div class="d-flex align-items-center gap-2 p-3 rounded border"
         style="background-color: #FFF3CD; color: #664D03;">
      <i class="bi bi-exclamation-triangle-fill fs-5"></i>
      <span>There {{ remainingProjectCount() === 1 ? 'is' : 'are' }}
        {{ remainingProjectCount() }} more
        {{ remainingProjectCount() === 1 ? 'project' : 'projects' }}
        to schedule for this job.</span>
    </div>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="onGoToJob()">Go to Job</button>
</div>
